module.exports = __webpack_public_path__ + "1c2780f0f769688705b987d1d0c79613.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter_sample_2x.png
// module id = 111
// module chunks = 0 1 2 3 4